import React from 'react';

import type { ExtensionManifest } from '@atlaskit/editor-common/extensions';
import { Box, xcss } from '@atlaskit/primitives';

const redactionBarStyles = xcss({
	display: 'inline-flex',
	aspectRatio: '2.8/1',
	height: '1lh',
	'@supports not (height: 1lh)': {
		height: '1.5em',
	},
	backgroundColor: 'color.background.neutral.bold.pressed',
	verticalAlign: 'middle',
	position: 'relative',
	':hover': {
		backgroundColor: 'color.background.neutral.bold',
		borderRadius: '3px',
	},
	':focus-visible': {
		backgroundColor: 'color.background.neutral.bold',
		borderRadius: '3px',
	},
});

export const redactionExtension = () => {
	return {
		title: 'Redaction',
		type: 'com.atlassian.guard-premium',
		key: 'redaction',
		description: 'Inserts redacted block.',
		icons: {
			// eslint-disable-next-line import/dynamic-import-chunkname
			'48': () => import('@atlaskit/icon/glyph/editor/addon'),
		},
		modules: {
			nodes: {
				default: {
					type: 'inlineExtension',
					render: async () => () => <Box as="span" xcss={redactionBarStyles} />,
				},
			},
		},
	} as ExtensionManifest;
};
